import { render } from "./product-packages.vue?vue&type=template&id=49b4047c&scoped=true"
import script from "./product-packages.vue?vue&type=script&lang=js"
export * from "./product-packages.vue?vue&type=script&lang=js"

import "./product-packages.vue?vue&type=style&index=0&id=49b4047c&lang=css"
import "./product-packages.vue?vue&type=style&index=1&id=49b4047c&scoped=true&lang=css"

import exportComponent from "C:\\development\\ON\\montalvo.ti\\dish-frontend-web-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49b4047c"]])

export default __exports__